import { z } from 'zod';

export const updateSearchDocumentSchema = z.object({
  uid: z.string(),
  query: z.string(),
});
export type UpdateSearchDocumentArgs = z.infer<
  typeof updateSearchDocumentSchema
>;
